import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {logProfilerTimingEvent} from 'performance/BenchlingProfiler';
import {
  composeStudiesCreateExperimentEventMetadata,
  ExecutionType,
  STUDIES_CREATE_EXPERIMENT_ENDED_EVENT,
  STUDIES_CREATE_EXPERIMENT_STARTED_EVENT,
} from 'performance/processStudiesEvents';
import {OnUnknownErrorAction} from 'studies/sidepanel/CreationTrayTask';
import {showExperimentCreationTrayTask} from 'studies/sidepanel/ExperimentCreationTrayTask';
import {BulkCreateExperimentsParam, createExperiments, CreateExperimentsResponse} from 'studies/StudyDAO';
import {withLoadingScreen} from 'util/Promises';

import {getProcedureRunUIStringForStudyType} from '../TypedStudyUtils';

export async function onCreateProcedureRuns(
  studyId: string,
  studyType: StudyType,
  creates: BulkCreateExperimentsParam['creates'],
  callbacks: {
    onSuccess: (response: CreateExperimentsResponse) => void;
    onOpen: (response: CreateExperimentsResponse) => void;
    onBackground: (isBackground: boolean) => void;
    onUnknownError: OnUnknownErrorAction;
  }
): Promise<void> {
  logProfilerTimingEvent(STUDIES_CREATE_EXPERIMENT_STARTED_EVENT);
  const initResponse = await withLoadingScreen(
    createExperiments(studyId, creates, {supportsAsync: true}),
    `Creating ${getProcedureRunUIStringForStudyType(studyType)}...`
  );
  if (!initResponse.async) {
    callbacks.onSuccess(initResponse.data);
    logProfilerTimingEvent(
      STUDIES_CREATE_EXPERIMENT_ENDED_EVENT,
      composeStudiesCreateExperimentEventMetadata(studyType, ExecutionType.SYNC)
    );
    return;
  }

  callbacks.onBackground(true);
  showExperimentCreationTrayTask(
    initResponse.data.taskId,
    initResponse.data.status_url,
    initResponse.taskMeta,
    creates.map((_) => ({studyId, studyType})),
    {
      onSuccess: (response) => {
        callbacks.onSuccess(response);
        logProfilerTimingEvent(
          STUDIES_CREATE_EXPERIMENT_ENDED_EVENT,
          composeStudiesCreateExperimentEventMetadata(studyType, ExecutionType.ASYNC)
        );
      },
      onOpen: callbacks.onOpen,
      onUnknownError: callbacks.onUnknownError,
      onRetry: () => {
        callbacks.onBackground(false);
      },
    },
    initResponse.data.timingMeta
  );
}
